import { InvalidEvent, useState } from "react";
import { Col, Form, FormFeedback, FormGroup, Label, Row } from "reactstrap";
import useValueList from "../../../hook/useValueList";
import { ISearchPositionTitlesInput } from "../../../types/position";
import { Action } from "../../../types/reducer-action";
import { getFormDataObject, parseCommonError } from "../../../utils/commons";
import BusyButton from "../../common/busy-button";
import { DataEntryEvent } from "../../common/data-entry-reducer";
import { SearchIcon } from "../../common/icons";
import Select from "../../common/select/select";
import TextInput from "../../common/text-input";
import { usePositionTitleDispatch } from "./position-manager-context";
import usePositionTitleApi from "./usePositionTitleApi";

function PositionSearchForm() {
  const dispatch = usePositionTitleDispatch();

  const [categories] = useValueList('ORG_CATEGORY_TYPE')

  const { searchPositionTitles, busy } = usePositionTitleApi();

  const [invalidName, setInvalidName] = useState('');

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    setInvalidName('');

    const input = getFormDataObject<ISearchPositionTitlesInput>(event.currentTarget);
    searchPositionTitles(input);
  };

  const handleReset = () => {
    setInvalidName('');
    dispatch(new Action(DataEntryEvent.NewDataSet));
  }

  const handleInvalid = (event: InvalidEvent<HTMLInputElement>) => {
    event.preventDefault();

    const { name, validity } = event.target;

    let msg: string;
    if (name === 'positionName' && validity.patternMismatch) {
      msg = "Only the following special characters are allowed: & ( ) / _ - ' . , : ;";
    } else {
      msg = parseCommonError(event);
    }
    setInvalidName(msg);
  };

  return (
    <Form onSubmit={handleSubmit} onReset={handleReset}>
      <Row>
        <Col md={6}>
          <FormGroup row>
            <Label for="category_id_filter" sm={4}>
              Filter by:
            </Label>
            <Col sm={6}>
              <Select id="category_id_filter" name="categoryId" disabled={busy}>
                {categories.filter(c => c.active).map(item =>
                  <option key={item.id} value={item.id}>{item.label}</option>
                )}
              </Select>
            </Col>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup row>
            <Label for="position_name_filter" sm={4}>Position/Role Title:</Label>
            <Col sm={6}>
              <TextInput trim id="position_name_filter" name="positionName"
                placeholder="Enter a position or role title" disabled={busy}
                invalid={!!invalidName} onInvalid={handleInvalid}
                pattern="^[A-Za-z0-9 \-\/\(\)\.,:;'&_]*$"
                minLength={2} maxLength={200}
                required />
              <FormFeedback invalid={invalidName} className="mt-0 mb-2">
                {invalidName}
              </FormFeedback>
            </Col>
          </FormGroup>
        </Col>
      </Row>

      <BusyButton type="submit" color="primary" className="action-link" value="Search"
        busy={busy} disabled={categories.length === 0}>
        <SearchIcon />
      </BusyButton>
    </Form>
  )
};

export default PositionSearchForm;
